<div class="eleco-project-tag" [class.nocolour]="!tagColour || tagColour == ''"
    [class.noicon]="!tagIconClass || tagIconClass == ''"
    [style.background-color]="tagColour" [style.color]="tagTextColour"
    [title]="tagTitle">
    <i class="{{ tagIconClass }}"></i>
    <span>{{ tagTitle }}</span>
</div>